export const HomeBodeFeatureType = {
  MarketData: 'market-data',
  ProMarketPlace: 'pro-market-place',
  CustomerSupport: 'customer-support',
};

export default {
  HomeBodeFeatureType,
};
